import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pxc-client-image',
  imports: [],
  templateUrl: './client-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientImageComponent {
  @Input() imagePath: string;

  cdnClientBaseUrl: string = environment.cdn.clientBaseUrl;
  defaultClientImagePath = 'default.png';
}
